import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import {
  mapToPercentages,
  mapUwtTypeToOptions,
} from 'modules/utils/mappers/leasingCalculatorCodesMapper';

// general data codes
export const selectGeneralDataCodesLoading = (state: RootState) =>
  state.leasingCalculatorCodes.generalDataCodes?.loading;

export const selectLeasingRecipientTypes = (state: RootState) =>
  state.leasingCalculatorCodes.generalDataCodes?.data?.leasingRecipientTypes;

export const selectLeasingRecipientTypesOptions = createSelector(
  selectLeasingRecipientTypes,
  (leasingRecipientTypes) => mapUwtTypeToOptions(leasingRecipientTypes),
);

export const selectLeasingTypes = (state: RootState) =>
  state.leasingCalculatorCodes.generalDataCodes?.data?.leasingTypes;

export const selectLeasingTypesOptions = createSelector(
  selectLeasingTypes,
  (leasingTypes) => mapUwtTypeToOptions(leasingTypes),
);

export const selectLeasingObjectSuppliers = (state: RootState) =>
  state.leasingCalculatorCodes.generalDataCodes?.data?.leasingObjectSuppliers;

export const selectLeasingObjectSuppliersOptions = createSelector(
  selectLeasingObjectSuppliers,
  (leasingObjectSuppliers) => mapUwtTypeToOptions(leasingObjectSuppliers),
);

export const selectLeasingCurrencies = (state: RootState) =>
  state.leasingCalculatorCodes.generalDataCodes?.data?.leasingCurrencies;

export const selectLeasingCurrenciesOptions = createSelector(
  selectLeasingCurrencies,
  (leasingCurrencies) => mapUwtTypeToOptions(leasingCurrencies),
);

// object data codes
export const selectLeasingObjectTypesAndMakesLoading = (state: RootState) =>
  state.leasingCalculatorCodes.leasingObjectTypesAndMakes?.loading;

export const selectLeasingObjectTypesAndMakes = (state: RootState) =>
  state.leasingCalculatorCodes.leasingObjectTypesAndMakes?.data;

export const selectLeasingObjectTypes = (state: RootState) =>
  state.leasingCalculatorCodes.leasingObjectTypesAndMakes?.data?.map(
    (item) => ({
      id: item.id,
      name: item.name,
    }),
  );

export const selectLeasingObjectTypesOptions = createSelector(
  selectLeasingObjectTypes,
  (leasingObjectTypes) => mapUwtTypeToOptions(leasingObjectTypes),
);

export const selectLeasingObjectDataByMake = (state: RootState) =>
  state.leasingCalculatorCodes.leasingObjectDataByMake?.data;

export const selectLeasingObjectFirstRegistrationYears = (state: RootState) =>
  state.leasingCalculatorCodes.leasingObjectFirstRegistrationYears;

export const selectLeasingObjectFirstRegistrationYearsOptions = createSelector(
  selectLeasingObjectFirstRegistrationYears,
  (leasingObjectFirstRegistrationYears) =>
    mapUwtTypeToOptions(leasingObjectFirstRegistrationYears),
);

export const selectLeasingObjectAgeCodes = (state: RootState) =>
  state.leasingCalculatorCodes.leasingObjectAgeCodes;

// financial data codes
export const selectLeasingTaxRateCodes = (state: RootState) =>
  state.leasingCalculatorCodes.leasingTaxRateCodes;

export const selectLeasingTaxRateCodesOptions = createSelector(
  selectLeasingTaxRateCodes,
  (leasingTaxRateCodes) =>
    mapUwtTypeToOptions(mapToPercentages(leasingTaxRateCodes)),
);

export const selectFinancingPeriodsLoading = (state: RootState) =>
  state.leasingCalculatorCodes.loading;

export const selectFinancingPeriods = (state: RootState) =>
  state.leasingCalculatorCodes.financingPeriods;

export const selectFinancingPeriodsOptions = createSelector(
  selectFinancingPeriods,
  (financingPeriods) => mapUwtTypeToOptions(financingPeriods),
);

export const selectLeasingPaymentPeriodTypes = (state: RootState) =>
  state.leasingCalculatorCodes.paymentPeriodTypes;

export const selectLeasingPaymentPeriodTypesOptions = createSelector(
  selectLeasingPaymentPeriodTypes,
  (leasingPaymentPeriodTypes) => mapUwtTypeToOptions(leasingPaymentPeriodTypes),
);

export const selectRemainingValues = (state: RootState) =>
    state.leasingCalculatorCodes.remainingValue;

